import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card";
import Loader from "../components/Loader";
import Search from "../components/Search";
import Select from "../components/Select";
import { useGetCountries } from "../services/countries";

const Home = () => {
  const [continent, setContinent] = useState(
    localStorage.getItem("continent") || "All",
  );
  const [input, setInput] = useState(localStorage.getItem("searchStr") || "");
  const navigate = useNavigate();

  const { isLoading, data } = useGetCountries(continent, input);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setInput(value);
    localStorage.setItem("searchStr", value);
  };

  const handleContinentChange = (e) => {
    const value = e.target.value;
    setContinent(value);
    localStorage.setItem("continent", value);
  };

  const navigateToDetails = (country) => {
    navigate(`/details/${country?.name}`, {
      state: { data: country },
    });
  };

  const clearSearch = () => {
    setInput("");
    // setContinent("All");
    localStorage.setItem("searchStr", "");
    // localStorage.setItem("continent", "All");
  };

  return (
    <main className="dark:bg-[var(--body-dark-color)] dark:text-white min-h-screen relative px-4 xl:px-[80px] md:px-[55px] pt-[70px]">
      <div className="flex flex-col md:flex-row md:items-center gap-y-10 md:justify-between pt-6">
        <Search
          input={input}
          handleChange={handleSearchChange}
          clearSearch={clearSearch}
        />
        <Select
          handleContinentChange={handleContinentChange}
          value={continent}
        />
      </div>

      <div className="grid gap-y-10 xl:gap-[75px] grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 pt-[28px]">
        {isLoading ? (
          <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
            <Loader />
          </div>
        ) : (
          data?.map((country) => (
            <Card
              key={country.name}
              name={country.name}
              population={country.population}
              navigate={() => navigateToDetails(country)}
              region={country.region}
              flags={country.flags}
              capital={country.capital}
            />
          ))
        )}
      </div>
    </main>
  );
};

export default Home;
